import { api } from './lib/api';
import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

// === Fix React + traductores (Google Translate) ===
// Hace defensivos insertBefore/removeChild para evitar el crash
// "Failed to execute 'insertBefore' on 'Node'" cuando una extensión
// del navegador (ej. Google Translate) altera los nodos de texto del DOM.
if (typeof Node === "function" && Node.prototype) {
  const originalRemoveChild = Node.prototype.removeChild;
  Node.prototype.removeChild = function (child) {
    if (child.parentNode !== this) {
      return child;
    }
    return originalRemoveChild.apply(this, arguments);
  };

  const originalInsertBefore = Node.prototype.insertBefore;
  Node.prototype.insertBefore = function (newNode, referenceNode) {
    if (referenceNode && referenceNode.parentNode !== this) {
      return newNode;
    }
    return originalInsertBefore.apply(this, arguments);
  };
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);

window.addEventListener('error', (e) => { try { api.reportClientError({ message: String(e.message || 'error'), url: window.location.pathname, stack: String(e.error?.stack || '') }); } catch (_) {} });
window.addEventListener('unhandledrejection', (e) => { const m = String(e.reason?.message || e.reason || ''); if (!/Request failed|Network Error|canceled/.test(m)) { try { api.reportClientError({ message: m, url: window.location.pathname, stack: String(e.reason?.stack || '') }); } catch (_) {} } });
